import protectionImage from "@/assets/protection.png";

export const HiddenBlessing = () => {
  return (
    <div 
      className="fixed pointer-events-none -z-10"
      style={{ 
        opacity: 0.0001,
        width: '1px',
        height: '1px',
        top: 0,
        left: 0,
        backgroundImage: `url(${protectionImage})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
      aria-hidden="true"
    />
  );
};
